import React, { useState } from "react";

function Gurudev() {
 return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/bg.jpg)',backgroundSize:'cover',backgroundPosition:'center'}}>
      </div>
      <div className="" style={{backgroundImage:'url(./images/event.jpeg)',padding:'10px',backgroundSize:'cover',backgroundAttachment:'fixed'}}>
        <div className="row" style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%'}}>
            
            <div className="col-md-12" style={{background:'#ffeccaf6',padding:'90px'}}>
                <div className="row" style={{marginBottom:'50px',borderBottom:'1px solid orange',paddingBottom:'15px',paddingTop:'15px',background:'orange',borderRadius:'15px'}}>
                    <div className="col-md-8" style={{display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',flexWrap:'wrap',gap:'25px'}}>
                       <center><p className="enquiry" style={{fontSize:'54pt',padding:'15px'}}>Gurudev</p> </center> 
                       <p className="enquiry" style={{fontSize:'20pt',marginBottom:'15px'}}>His Purvashram as little Velayudhan</p> 
                       <p className="enquiry" style={{color:'black',marginTop:'-20px'}}>Founder: Swamy Abhedananda Maharaj</p>
                    </div>
                    <div className="col-md-4">
                        <img src="./images/guruji.png" alt="Guruji" style={{width:'100%'}} />
                    </div>
                </div>
                
                <div className="row" style={{marginBottom:'50px',paddingBottom:'15px',paddingTop:'15px'}}>
                    <div className="row" style={{marginBottom:'50px',background:'white',borderRadius:'15px'}}>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>1936 - Rishikesh</h1>
                            <p>
                                He stood, facing the Himalayas, his palms folded like a Lotus Bud Embracing his feet were the gentle waves of the Ganges…perhaps his lips were chanting some holy verses.
                                His face radiant in the morning sun. Slowly, he turned back and climbed up. His newly attired saffron robes fluttered in the cool mountain breeze.
                                He was not just a ‘HE’ but a holy soul.
                                He was SADGURU SWAMI ABHEDANANDA MAHARAJ
                                Simplicity, Love and Devotion personified.
                                Here started the journey of a Mahatma a journey to the hearts of Bharathavarsha to spread the message of devotion, love and the power of Lord’s name.
                            </p>
                            <div className="nexttimeline">
                               <i class="fa fa-arrow-circle-o-right" aria-hidden="true"></i>
                            </div>
                        </div>
                            
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>1954 - Trivandrum</h1>
                            <p>
                                That was when we started hearing in our half sleep, half awakening moments of early mornings, outside the closed windows, in the streets, the ever soothing Mahamantra –
                                HARE RAMA HARE RAMA RAMA RAMA HARE HARE HARE KRISHNA HARE KRISHNA KRISHNA KRISHNA HARE HARE.
                                You and I get the urge to open our windows and run down to the street, though the cozy, morning bed was tempting.
                            </p>
                             <div className="nexttimeline">
                               <i class="fa fa-arrow-circle-o-right" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>29th Oct, 1983, Haridwar</h1>
                            <p>
                                He returned to the lap of Mother Ganges for his eternal peace.
                            </p>
                             <div className="nexttimeline">
                               <i class="fa fa-arrow-circle-o-right" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                    </div>
                    {/* details */}
                    <div className="row" style={{marginBottom:'50px',background:'white',borderRadius:'15px'}}>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>Friends</h1>
                            <p>
                                The years between that morning when Ganges chanted along with him and one weepy evening when she took away his cotton-clad worldly remains, tell the history of a vibrant and fruitful mission of a great ascetic.
It was a mission of awakening the sleeping souls of yours and mine.
From the tempting beds of silky worldly attachments to the open street, where the bliss of God awareness awaits everybody through Bhakthi, Service and Namajapa.
He was born on 8th April, 1909, to Sri Krishna Pillai and Smt. Lakshmi Pillai at Parassala, Trivandrum. Named Velayudhan, the child showed an inclination to pursue the spiritual path. This unusual spark was noticed by his paternal uncle Sree Padmanabha Pillai, himself a God realized soul.

                            </p>
                            <div className="nexttimeline">
                              <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                        </div>
                            
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>His spiritual voyage</h1>
                            <p>
                                The young Velayudhan grew up listening to stories and hymns about the Lord from his mother, a very pious lady and his uncle Sri. Padmanabha Pillai. Thus began in the young boy a journey in search of Supreme knowledge and devotion with a true urge to spread the message of love to humanity.
                            </p>
                             <div className="nexttimeline">
                                 <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>The Midas touch</h1>
                            <p>
                                At the age of 14, he met the great saint and social reformer of Kerala Sri Vidhyadhiraja Chattampi Swami. The blessing of the sage kindled the inborn yearning for spiritual life. He decided to renounce worldly life in search of a higher purpose in life to lead millions to a path of goodness.
                            </p>
                             <div className="nexttimeline">
                               <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>The Ascetic life – Parivrajaka</h1>
                            <p>
                                Velayudhan left home and traveled throughout the country. He wandered among saints and spiritual seekers. He mastered spiritual textbooks and treatises like Bhagavat Gita, Bhagavatham, Upanishads, etc. He visited various temples and spiritual centers. He became well versed in Sanskrit and many other Indian languages.
During the course of his travel he had the rare privilege of meeting Mahatmas like Ramana Maharshi of Thiruvannamalai. The bliss of satsangh strengthened Velayudhan’s naturally ascetic temperament.
The Divine Metamorphosis – A savione is born.
The pilgrimages and divine satsanghs had transformed 27 year old Velayudhan to a true enlightened ascetic. In 1936 he was formally initiated into Sanyasa by Swamy Swaroopananda of Kailas Ashramam, Rishikesh. Swamy Abhedananda Bharati was born for the upliftment of mankind.

                            </p>
                             <div className="nexttimeline">
                               <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>Back home – as Swamy Abhedananda</h1>
                            <p>
                                Swamiji mingled among people and exhorted them to take to spiritual practices.
His strength was his humility – the ‘Dasanu dasa’ bhava endeared him to peoples’ hearts. His towering personality, blessed with a melodious voice, Swamiji’s Bhajans attracted a large number of devotees. His discourses on ‘Gita’ and other texts propagated ‘Bhakthi’ among people.


                            </p>
                             <div className="nexttimeline">
                               <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>His inspiration:- ‘Chaithanya Mahaprabhu’</h1>
                            <p>
                                He was immensely influenced by the life and teachings of Chaithanya Mahaprabhu who lived in the 16th century in Bengal and one of the best exponents of Bhakthi Yoga. Drawing inspiration from Chaithanya Mahaprabhus’ unstinted faith in the power of Lord’s Name and selfless love for the Divine, Gurudev, immersed fully into a life of Nama Pracharanam.
With hands held high, shouting ‘Hari Bol’, devotees used to dance in ecstasy singing Hare Rama,… throughg the busy streets of Thiruvananthapuram led by Gurudev.



                            </p>
                             <div className="nexttimeline">
                               <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>  
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>His Mission: His methods</h1>
                            <p>
                                Gurudev propagated that all men are equal and they have equal rights to practice and preach spirituality, as also the right to perform the rites prescribed by the scriptures. He established this with the authority of srutis and smritis.
His mission was to eradicate the curse of caste system in the society. He always taught that religion is to see God in every human being, in every word, thought, action and breath. Religion should not segregate the society. For that he evolved programmes to bring together people to share the bliss of spirituality and oneness</p>
                             <div className="nexttimeline">
                               <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>Bhajan</h1>
                            <p>
                                Singing the Lord’s name with Bhakthi – He taught that there is no audience during a Bhajan, which differentiates bhajan from a musical performance. ‘Sing sing sing aloud till your heart breaks’ he exhorted.</p>
                             <div className="nexttimeline">
                               <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>Bheri</h1>
                            <p>
                                Taking the Lords name to every nook and corner of the country, Gurudev along with his devotees practiced bheri, shedding away egos and narrow thinking, dancing away along busy streets chanting the Lord’s name.</p>
                             <div className="nexttimeline">
                               <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>Kodiarchana</h1>
                            <p>
                                In 1958, Swamiji introduced the idea of Kodi Archana, where in he envisaged that devotees irrespective of caste or creed could join together chanting the divine mahamantra and conduct archana, a crore (Kodi) times. By this Yajna, apart from instilling the message of love and devotion, in human minds, Swamiji had a greater vision of warring off evils of caste and class discrimination in the society. This mass programme that Gurudev envisaged is still being continued in different parts of the country.</p>
                             <div className="nexttimeline">
                               <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>The Institutions</h1>
                            <p>
                                In the year 1945-46 Swamiji, bowing to an increasing demand from devotees founded an Ashramam at Arayoor dedicated to Sri Chattambi Swamigal. Soon a temple was consecrated and Gurudev installed a ‘Mirror’ as a deity there.
This ashramam is in Neyyattinkara Taluk, away from the hustle and bustle of Trivandrum city, set amidst natural surroundings and peaceful ambience, where devotees can enjoy a perfect spiritual retreat.</p>
                             <div className="nexttimeline">
                               <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="timeline">
                                <h1>Abhedashramam</h1>
                            <p>
                                In 1954, the devotees of Trivandrum city made available a land inside East Fort, the busiest commercial area of the city. Here the ringing of the temple bells and the reverberation of the Mahamantra eclipse the hoot and soot of the busy traffic around.</p>
                             <div className="nexttimeline">
                               <i class="fa fa-star-o" aria-hidden="true"></i>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginBottom:'50px',background:'orange',borderRadius:'15px'}}>
                        <div className="col-md-8">
                            <div className="timeline" style={{background:'orange'}}>
                                <h1>More about Satgurudev</h1>
                            <p>
                                Everyone who was blessed to contact Swami Abhedananda once in life should have felt his astounding equanimity, innocence, humility, endearing traits and versatility.
Abheda one without any “Bhed” or difference or discrimination.
He was the living example of the dictum that the beauty of man lay in the beauty of his mind. He used to make his devotees wonder – was he ‘love’ personified? He deeply and sincerely loved one and all who contacted him. He made each of his devotees feel special. The flowing nectar of Gurudev’s love is always perennial, inexhaustible and boundless.
Gurudev had mastery over most of the arts known to man. His early friends know his mastery as an actor on the stage. Swamiji also had written and directed plays on stage during many occasions. Devotees who had taken part and had the good fortune to be directed in the plays by Gurudev treasures those precious memories. Gurudev the ‘saffron clad sanyasi’ – was he a loss for the world theatre, one often wonders.
Gurudev’s command over music attracted great many devotees from different parts of the country and from all walks of life. Swamy Chinmayananda, the founder of Chinmaya Mission and a contemporary of Gurudev refers to his melodious singing as ‘devotion pouring out from Meera – throat of Swamiji”. For hours together Gurudev used to drown the devotees into a musical and devotional ecstasy.
Gurudev was a great cook and equally wonderful host. ADHIDHI DEVO BAVA is strictly followed in the ashramam even today. Everyday food is provided free to anyone who visits the Ashramam.
Gurudev was a great orator and discourser. To be in his divine presence itself was Satsangh for his devotees. But greater bliss and joy was to listen to his enlightening words. He was a man of great humour and wit as well. Seasoned properly with anecdotes and humour, Gurudev’s Satsangh used to be a celestial treat for devotees.
<br />
Gurudev was a fine writer. He has authored many books. (Refer section on Books)<br />
Gurudev’s character of non attachment never allowed him to stay in a particular spot, even in the Ashramam for more days. He thus taught his devotees, that the institution is above individuals.</p>
                            
                            </div>
                        </div>
                        <div className="col-md-4" style={{backgroundImage:'url(./images/guruji.png)',backgroundSize:'cover',backgroundPosition:'center'}}>
                            
                        </div>
                    </div>
                   
                </div>
                
                 <div className="row" style={{marginBottom:'50px',borderRadius:'15px',background:'rgba(154, 87, 0, 1)',boxShadow: '0px 0px 500px black'}}>
                        
                            <div className="col-md-6">
                                <div className="moreabout">
                                     <h1>Swami Prabhodananda</h1>
                                <p>
                                    An old school mate of Gurudev Sri. Prabhodananda Swamiji succeeded Sri. V. N. Govindan Pillai as the secretary of the ashramam.

His purvashram name was Sri. Prabhakaran Nair. He was a renowned teacher and was working as the head master of a school, when he came into association with Swamiji. From 1940 onwards he used to actively involve in the activities of Gurudev. Endowed with very rare qualities of mind and brain, he had great organization skills. He could guide and inspire others and infuse the true spirit of devotion which was personified in him. A great upasak of Mother Goddess, he was also popular for his knowledge in martial arts. After the Mahasamadhi of Abhedananda Swamiji, he held office as the ‘Mahanth’ of Abhedashramam, Trivandrum and the President of the Ashramam Trust. He attained Samadhi in September, 1989.
                                </p>
                                </div>
                               
                            </div>
                            <div className="col-md-6">
                                <div className="moreabout">
                                     <h1>Swami Bhajanananda</h1>
                                <p>
                                    Swami Bhajanananda became the President of Abhedashramam on 28th October 1989. He was a very dear disciple of Grudev. He belonged to Amaravila, near Arayoor Ashramam and as a young boy, Appu or Sadasivan Nair used to visit the Ashram and spend time with Gurudev. In word and spirit, he was a true disciple of Gurudev. In 1959, he undertook a pilgrimage to all holy places including Mount Kailas, without a single penny in hand as per the instruction of Gurudev. The life of a Parivrajaka or a pilgrim was thus demonstrated to the world by Gurudev through his dear disciple, when faith in Lord, erases any doubts about trivialities in life. In 1977, he was initiated to Sanyasa by Gurudev. Bhajanananda Swamiji used to sing Bhajans very fondly and no other name would have been more apt. The relationship between Gurudev and Bhajanananda Swamiji epitomizes the ideal Guru-Shishya tradition and practice. A totally devoted disciple, he was an unfathomable source of incredible organizing skill. The great soul attained Samadhi on October 1st 2005.
                                </p>
                                </div>
                               
                            </div>
                        
                    </div>
           </div> 
          
                      
        </div>
        
        
      </div>
    </div>
  );
}

export default Gurudev;